export default __webpack_public_path__ + "static/media/mini-signal.26088a8d.svg";